import { render } from "./Event.vue?vue&type=template&id=5afff13c&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=5afff13c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afff13c"]])

export default __exports__